<!-- 米测MeLab首页 -->
<template>
    <div class="home">
        <!-- 轮播图 -->
        <div class="panel">
            <el-carousel :interval="5000">
                <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                    <el-image :src="item.url" style="width:100%;height: 580px;" @click="jump(item)"
                        class="banner_item"></el-image>
                </el-carousel-item>
            </el-carousel>
            <!-- 加入米测vip -->
            <div class="join_mc">
                <div v-for="(item, index) in list" class="join_mc_item" :key="index" @click="clickIt(item)">
                    <el-image class="join_mc_icon" :src="item.src"></el-image>
                    <div class="join_mc_content">
                        <div class="join_mc_title">{{ item.title }}</div>
                        <div class="join_mc_subtitle">{{ item.subTitle }}</div>
                    </div>

                    <div v-if="item.tag" class="join_tag">{{item.tag}}</div>
                </div>
            </div>
        </div>

        <!-- 金刚区 -->
        <div class="gold">
            <div class="tabs">
                <div class="tab_item" v-for="(item, index) in goldTabs" :key="index">
                    <div class="line"></div> {{ item.name }} <div class="line"></div>

                    <div class="eng">IN-SITU ZONE</div>
                </div>
            </div>
            <div class="content" v-if="goldActive == 0">
                <div class="content_item" v-for="(item, index) in goodsList" :key="index"
                    @click.prevent="viewOriginalArea(item)">
                    <div class="left">
                        <div class="counts">
                            已预约&nbsp;<span>{{ item.buyCount }}次</span>&nbsp; | &nbsp;满意度&nbsp;<span>{{ item.grade
                                }}%</span>
                        </div>
                        <img class="img" :src="item.original && item.original.length > 0 ? item.original[0] : ''" />
                        <div class="btn" @click.stop="appointNow(item.id)">立即预约</div>
                        <div class="left_txt">{{ item.signature }}</div>
                    </div>
                    <div class="right">
                        <el-popover placement="top-start" :width="200" trigger="hover" :content="item.name">
                            <template #reference>
                                <div class="right_title">{{ item.name }}</div>
                            </template>
                        </el-popover>

                        <div class="status">
                            <el-tag class="status_item" v-for="(inner, index2) in item.tag" :key="index2"
                                :type="index2 == 0 ? 'success' : 'warning'">
                                {{ inner }}
                            </el-tag>
                        </div>
                        <!-- <div class="type">仪器型号：{{ item.model }}</div> -->
                        <el-popover placement="top-start" :width="400" trigger="hover" :content="`仪器型号：${item.model}`">
                            <template #reference>
                                <div class="type">仪器型号：{{ item.model }}</div>
                            </template>
                        </el-popover>

                        <el-popover placement="top-start" :width="400" trigger="hover"
                            :content="`${item.introductory}`">
                            <template #reference>
                                <div class="right_desc">{{ item.introductory }}</div>
                            </template>
                        </el-popover>
                    </div>
                </div>
            </div>

            <div class="content1" v-if="goldActive == 1">
                <div class="content1_item" v-for="(item, index) in list1" :key="index">
                    <img class="img" :src="item.src" />
                    <div class="title">{{ item.title }}</div>
                    <div class="subtitle">{{ item.subTitle }}</div>
                </div>
            </div>
        </div>
        <!-- 原位设计测试专家 -->
        <div class="test">
            <div class="title">
                <div class="line"></div>
                原位表征测试专家
                <div class="line"></div>
                <div class="eng">TESTING EXPERT</div>
            </div>
            <div class="desc1">原位表征（in situ
                charactering）是一种在物质或系统实际工作环境中进行实时、实地、表征的表征和观察的方法法，广泛评估材料科学、化学、地球科学、纳米科技等领域，原位表征是一种强有力的工具，有助于科学家们更全面地了解正面了解材料和过程的性质。通过实时、直观、直观的表征和观察，科学家们可以获得更准确、更详细的数据，为科学研究和工程应用大量提供支持。
            </div>
            <img class="img" src="@/assets/imgs/homeIcon/perfessional1.png" />
            <div class="desc2">
                在材料科学与工程的缺陷领域中，原位表征测试技术扮演着至关重要的角色。为了推动这一领域的创新与发展，我们自豪地推出“原位表征测试专家平台”——一套技术、数据、服务于一体的综合性平台，旨在为用户提供高效、精准、便捷的原位表征测试解决方案。
            </div>
            <div class="imgs">
                <div class="item" v-for="(item, index) in imgs" :key="index">
                    <img :src="item.src" alt="" class="item_img">
                    <div class="title">{{ item.title }}</div>
                    <div class="subtitle">{{ item.subTitle }}</div>
                </div>
            </div>
            <div class="test_btn" @click="$router.push('/category')">马上测试</div>
        </div>


        <div class="expert_comments">
            <div class="title">
                <div class="line"></div>
                名家讲堂
                <div class="line"></div>
                <div class="eng">LECTURE HALL</div>
            </div>
            <div class="content">
                <div class="content_item" v-for="item in lectureList" :key="item.id">
                    <div class="top" @click="showVideo(item)">
                        <!-- <img oncontextmenu="return false" :src="item.cover" alt="" /> -->
                        <el-image :src="item.cover"></el-image>
                        <div class="play">
                            <img src="@/assets/imgs/play.png" alt="" />
                        </div>
                    </div>
                    <div class="bottom">
                        <div class="info">
                            <div class="face">
                                <xl-img :src="item.dep.face" alt="" />
                            </div>
                            <div class="text">
                                <div class="name">{{ item.dep.name }}</div>
                                <div class="theme">主题：{{ item.name }}</div>
                            </div>
                        </div>
                        <div class="dep">
                            <p v-for="(i, ix) in item.dep.depList" :key="ix">
                                <span class="icon"></span>
                                <span class="text">{{ i.text }}</span>
                            </p>
                        </div>
                    </div>
                    <!-- <div class="video">
            <video
              :src="item.url"
              controls="controls"
              controlsList="nodownload"
              :poster="item.cover"
              :ref="`video${index}`"
              @play="videoPlay($event, `video${index}`)"
            ></video>
          </div> -->
                    <!-- <div class="content_text">
            <div class="lecture_name single_omission">
              {{ item.name }}
            </div>
            <el-popover
              placement="top-start"
              trigger="hover"
              width="300"
              :content="item.dep"
            >
              <div slot="reference" class="lecture_introduce multi_omission">
                {{ item.dep }}
              </div>
            </el-popover>
          </div> -->
                </div>
            </div>
        </div>
        <!-- 期刊速递 -->
        <div class="paper" id="paper_speed">
            <div class="title">
                <div class="line"></div>
                顶刊速递
                <div class="line"></div>
                <div class="eng">TOP MAGZZINE</div>
            </div>
            <div class="content" v-if="paperList.length">
                <div class="item" v-for="(item, index) in paperList" :key="index" @click="viewPaper(item)">
                    <img :src="item.thumbUrl" alt="" class="img">
                    <div class="subtitle">{{ item.title }}</div>
                    <div class="foot">
                        <div class="foot_item">
                            <img src="@/assets/imgs/homeIcon/time.png" alt="" class="icon">
                            <div>时间：{{ item.publishTime?.slice(0, 11) }}</div>
                        </div>
                        <div class="foot_item">
                            <img src="@/assets/imgs/homeIcon/look.png" alt="" class="icon">
                            <div class="look">浏览：{{ item.viewNum }}</div>
                        </div>
                        <div class="foot_item">
                            <img src="@/assets/imgs/homeIcon/source.png" alt="" class="icon">
                            <div class="source">来源：{{ item.source }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="more_btn" @click="$router.push('/journalList')">查看更多</div>
        </div>

        <!-- 服务客户 -->
        <div class="service_custom">
            <div class="service_title">
                <div class="line"></div> 服务客户 <div class="line"></div>
                <div class="eng">SERVING CUSTOMERS</div>
            </div>

            <vue-seamless-scroll :data="serviceList" :class-option="classOption" class="service_content">
                <ul class="ul-item">
                    <li class="li-item" v-for="(inner, index) in serviceList" :key="index">
                        <div class="logo_item_wrap" v-for="(src, idx) in inner" :key="idx">
                            <img :src="src" alt="" class="logo_item">
                        </div>
                    </li>
                </ul>
            </vue-seamless-scroll>
        </div>





        <video-dialog :visible="videoDialogVisible" :activeVideo="activeVideo"
            @closeDialog="videoDialogVisible = false"></video-dialog>
    </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import XlImg from "@/components/xyhComps/Xl-img.vue";
import { appendQuery } from "@/tool";
import { cookieStorage } from "@/tool/storage";
import { mapState, mapActions, mapMutations } from 'vuex'
import { getAllCategory, searchKeyword } from '@/api/goods'
import { getJournalSpeed, getVideoList, getBanner, getTestSelect, getTagList } from '@/api/home'
import VideoDialog from "@/components/dialogComponents/videoDialog.vue";
import { parseObjVal } from "@/tool";
// import MessageBox from '@/components/messageBox.vue'
export default {
    name: 'HomeView',
    components: {
        VideoDialog,
        XlImg,
        vueSeamlessScroll
        //   RightBar,
        // MessageBox,
    },
    data() {
        return {
            classOption: {
                limitMoveNum: 4,
                direction: 2,
            },

            videoDialogVisible: false,
            activeVideo: {},
            activeView: 'homeView',
            showDrawer: false,
            currentPage: 1,
            journalPages: 1,
            mainCategoryId: process.env.VUE_APP_MODE === 'production' ? '10050' : '10040',
            list: [
                { title: '加入米测VIP', subTitle: '首样免费测/先测试后付费', src: require('@/assets/imgs/homeIcon/vip.png'), path: '/understandMember' },
                // { title: '预存有礼', subTitle: '预存最高增值10%', src: require('@/assets/imgs/homeIcon/gift2.png'), path: '/preStorageStatic' },
                { title: '活动专区', subTitle: '活动多多惊喜不停', src: require('@/assets/imgs/homeIcon/huodong.png'), path: '/activityArea' },
                { title: '文献求助', subTitle: '秒看文献无忧愁', src: require('@/assets/imgs/homeIcon/journal.png'), path: '/literatureHelp' },
                { title: '论文致谢', subTitle: '最高奖励2000元', src: require('@/assets/imgs/homeIcon/thank.png'), path: '/paperThank' },
            ],
            goldTabs: [
                { name: '原位专区', active: false },
            ],
            goodsList: [],
            goldActive: 0,
            list1: [
                { src: '', title: '同步辐射XAS', subTitle: '部分可测原位测试' },
                { src: '', title: '同步辐射XAS', subTitle: '部分可测原位测试' },
                { src: '', title: '同步辐射XAS', subTitle: '部分可测原位测试' },
                { src: '', title: '同步辐射XAS', subTitle: '部分可测原位测试' },
                { src: '', title: '同步辐射XAS', subTitle: '部分可测原位测试' },
                { src: '', title: '同步辐射XAS', subTitle: '部分可测原位测试' },
                { src: '', title: '同步辐射XAS', subTitle: '部分可测原位测试' },
                { src: '', title: '同步辐射XAS', subTitle: '部分可测原位测试' }
            ],
            list2: [
                { src: '', title: '原位', status: ['变温', '拉伸'], type: '天津三英', type_eng: 'NanoVoxel2000/4000XLAB-2000/1000、', desc: '原位红外主要分为DRIFTS漫反射和ATR消除全反射原位红外。广泛表征催化剂表征（吸附态，固体表面酸性，活性中心）研究，反应动力学研究，以及聚合物反应动力学' },
                { src: '', title: '原位', status: ['变温', '拉伸'], type: '天津三英', type_eng: 'NanoVoxel2000/4000XLAB-2000/1000、', desc: '原位红外主要分为DRIFTS漫反射和ATR消除全反射原位红外。广泛表征催化剂表征（吸附态，固体表面酸性，活性中心）研究，反应动力学研究，以及聚合物反应动力学' },
                { src: '', title: '原位', status: ['变温', '拉伸'], type: '天津三英', type_eng: 'NanoVoxel2000/4000XLAB-2000/1000、', desc: '原位红外主要分为DRIFTS漫反射和ATR消除全反射原位红外。广泛表征催化剂表征（吸附态，固体表面酸性，活性中心）研究，反应动力学研究，以及聚合物反应动力学' },
                { src: '', title: '原位', status: ['变温', '拉伸'], type: '天津三英', type_eng: 'NanoVoxel2000/4000XLAB-2000/1000、', desc: '原位红外主要分为DRIFTS漫反射和ATR消除全反射原位红外。广泛表征催化剂表征（吸附态，固体表面酸性，活性中心）研究，反应动力学研究，以及聚合物反应动力学' }
            ],
            imgs: [
                { src: require('@/assets/imgs/homeIcon/perfessional2.png'), title: '综合监测', subTitle: "原位表征平台能够实时监测物质或系统在实际工作环境中的动态变化，提供高分辨率的信息。" },
                { src: require('@/assets/imgs/homeIcon/perfessional3.png'), title: '实地观察', subTitle: "实验或安装是在物质基础的实际环上境中进行的，能够提供更真实的资料物料性能数据。" },
                { src: require('@/assets/imgs/homeIcon/perfessional4.png'), title: '实物测试', subTitle: "着眼于对实际物质的直接观察和衡量尝试，有助于理解材料在实际使用中的行为，并提供更准确的性能预测。" },
            ],
            lectureList: [],

            paperList: [],
            serviceList: [
                [require('@/assets/imgs/schoolsImg/school1.png'),
                require('@/assets/imgs/schoolsImg/school2.png'),
                require('@/assets/imgs/schoolsImg/school3.svg'),
                require('@/assets/imgs/schoolsImg/school4.png'),
                require('@/assets/imgs/schoolsImg/school5.png'),
                require('@/assets/imgs/schoolsImg/school6.png'),
                require('@/assets/imgs/schoolsImg/school7.png'),
                require('@/assets/imgs/schoolsImg/school8.png'),
                require('@/assets/imgs/schoolsImg/school9.png'),
                require('@/assets/imgs/schoolsImg/school10.png'),
                require('@/assets/imgs/schoolsImg/school11.png'),
                require('@/assets/imgs/schoolsImg/school12.png'),],

                [require('@/assets/imgs/schoolsImg/school13.png'),
                require('@/assets/imgs/schoolsImg/school14.png'),
                require('@/assets/imgs/schoolsImg/school15.png'),
                require('@/assets/imgs/schoolsImg/school16.png'),
                require('@/assets/imgs/schoolsImg/school17.png'),
                require('@/assets/imgs/schoolsImg/school18.png'),
                require('@/assets/imgs/schoolsImg/school19.png'),
                require('@/assets/imgs/schoolsImg/school20.png'),
                require('@/assets/imgs/schoolsImg/school21.png'),
                require('@/assets/imgs/schoolsImg/school22.png'),
                require('@/assets/imgs/schoolsImg/school23.png'),
                require('@/assets/imgs/schoolsImg/school24.png')],

                [require('@/assets/imgs/schoolsImg/school25.png'),
                require('@/assets/imgs/schoolsImg/school26.png'),
                require('@/assets/imgs/schoolsImg/school27.png'),
                require('@/assets/imgs/schoolsImg/school28.png'),
                require('@/assets/imgs/schoolsImg/school29.png'),
                require('@/assets/imgs/schoolsImg/school30.png'),
                require('@/assets/imgs/schoolsImg/school31.png'),
                require('@/assets/imgs/schoolsImg/school32.png'),
                require('@/assets/imgs/schoolsImg/school33.png'),
                require('@/assets/imgs/schoolsImg/school34.png'),
                require('@/assets/imgs/schoolsImg/school35.png'),
                require('@/assets/imgs/schoolsImg/school36.png')],

                [require('@/assets/imgs/schoolsImg/school37.png'),
                require('@/assets/imgs/schoolsImg/school38.png'),
                require('@/assets/imgs/schoolsImg/school39.png'),
                require('@/assets/imgs/schoolsImg/school40.png'),
                require('@/assets/imgs/schoolsImg/school41.png'),
                require('@/assets/imgs/schoolsImg/school42.png'),
                require('@/assets/imgs/schoolsImg/school43.png'),
                require('@/assets/imgs/schoolsImg/school44.png'),
                require('@/assets/imgs/schoolsImg/school45.png'),
                require('@/assets/imgs/schoolsImg/school46.png'),
                require('@/assets/imgs/schoolsImg/school47.png'),
                require('@/assets/imgs/schoolsImg/school48.png')],


            ],
            qun: [
                { no: '文献求助QQ群：949294810' },
                { no: '原位表征QQ交流群：949294810' },
                { no: '测试交流QQ群：949294810' },
            ],
            list3: ['平台相关', '网站指南', '协议条款', '服务用户'],
            list4: ['关于我们', '新手指引', '用户协议', '意见反馈', '合作伙伴', '技术顾问', '隐私条款', '发布需求'],
            list5: [
                { src: '', text: '米测MeLab公众号' },
                { src: '', text: '米测MeLab公众号' },
            ],
            viewList: [
                {
                    name: '首页',
                    compsName: 'homeView',
                    path: '/home',
                    showDrawer: false
                },
                {
                    name: '测试分类',
                    compsName: 'category',
                    path: '/category',
                    showDrawer: true
                },
                {
                    name: '同步辐射',
                    compsName: 'syncRdiation',
                    path: '/syncRdiation',
                    showDrawer: false
                }
            ],
            drawerData: [],
            drawerActive: 1,
            bannerList: []
        }
    },
    created() {
        this.getTagListFn()
        this.getAllCategory()
        this.getVideoList()
        this.getJournalSpeed()
        this.getMainCategoryGoods()
        this.getBanner()

    },
    computed: {
        ...mapState('user', ['userInfo']),
        activeDrawerData() {
            return this.drawerData[this.drawerActive - 1]
        }
    },

    methods: {

        getTagListFn() {
            getTagList().then((res) => {
                if(res.length){
                    res.forEach(item => {
                        this.list.forEach(i => {
                            if(item.module == i.title){
                                i.tag = item.tag
                            }
                        })
                    })
                }

            })
        },

        appointNow(id) {
            this.$router.push(`/placeOrderView/${id}`);
        },

        // 点击轮播图跳转
        jump(item) {
            if (item.redirectUrl) {
                const { access_token, uid } = this.userInfo;
                let uuid = cookieStorage.getUuid();
                if (access_token) {
                    window.open(
                        appendQuery(item.redirectUrl, {
                            access_token,
                            uid,
                            uuid,
                        })
                    );
                } else {
                    window.open(item.redirectUrl);
                }
            }
        },
        ...mapActions('user', ['logout']),
        ...mapMutations('user', ['clearUserInfo']),
        // 获取轮播图
        async getBanner() {
            let data = await getBanner();
            console.log('data', data);
            this.bannerList = data;
        },

        getMainCategoryGoods() {
            getTestSelect().then(res => {
                //组装数据
                res.forEach(item => { parseObjVal(item, ['original', 'tag']) });
                this.goodsList = res;
            })
        },
        clickIt(item) {
            if (item.path) {
                this.$router.push(item.path)
            }
            // if(item.anchorPoint){
            //     const sectionElement = document.querySelector('#paper_speed');
            //     sectionElement.scrollIntoView({ behavior: 'smooth' });
            // }
        },

        // 获取期刊速递
        getJournalSpeed() {
            getJournalSpeed({ currentPage: this.currentPage, pageSize: 9 }).then(res => {
                console.log('res', res);

                this.paperList = res.records || []
                this.journalPages = res.pages
                // this.paperList = [...res.records,...res.records,...res.records,res.records]
            })
        },

        // 期刊速递分页
        changePage(type) {
            switch (type) {
                // 上一页不能小于1
                case 'prev':
                    if (this.currentPage <= 1) return
                    this.currentPage--
                    this.getJournalSpeed()
                    break;
                // 下一页不能大于最大页码
                case 'next':
                    if (this.currentPage + 1 > this.journalPages) return
                    this.currentPage++
                    this.getJournalSpeed()
                    break;
            }
        },

        // 跳转期刊速递详情
        viewPaper(item) {
            console.log('item', item);
            this.$router.push({ name: 'paperDetail', query: { id: item.id } })
        },
        // 跳转搜索结果页面
        toSearchResult() {
            if (!this.searchText) {
                // this.searchText = "";
                return
            }
            let path = `/searchResult?keyword=${this.searchText}`
            this.$router.push(path)
            this.$EventBus.$emit('search', this.searchText)
        },
        // 获取搜索列表
        getSearchList(searchStr, callBack) {
            if (!searchStr) {
                callBack([])
            } else {
                searchKeyword({ keyword: searchStr }).then((res) => {
                    callBack(res)
                })
            }
        },

        // 查看原位专区详情
        viewOriginalArea(item) {

            this.$router.push({
                path: 'professionalDetail',
                query: {
                    goodsId: item.id,
                    categoryId: this.mainCategoryId
                }
            })
        },

        clickSearchItem(item) {
            if (item.id) {
                this.$router.push(`/details/${item.id}`)
            }
        },

        // 获取分类的数据
        getAllCategory() {
            getAllCategory().then((res) => {
                this.drawerData = res
            })
        },

        // 获取名家讲堂
        getVideoList() {
            getVideoList({ type: "PRO_FORUM" }).then((res) => {
                this.lectureList = res.slice(0, 4).map((i) => {
                    i.dep = JSON.parse(i.dep);
                    return i;
                });


            });
        },

        // 名家讲堂播放视频
        showVideo(item) {
            console.log('lectureList', this.lectureList);
            this.activeVideo = item;
            this.videoDialogVisible = true;
        },

        // 切换tba
        switchTab(item) {
            this.activeView = item.path
            this.showDrawer = false
            this.$router.push(item.path)
        },
        // 点击抽屉的子项 跳转页面
        toPath(item) {
            if (item.path) {
                if (item.path == '/mall') {
                    window.open('https://mall.micetech.cn/#/searchResult')
                } else {
                    let path = `${item.path}?id=${item.id}`
                    this.$router.push(path)
                }
            } else {
                this.$router.push(`/category?id=${item.id}`)
            }
            // let path;
            // if (isParent) {
            //   path = item.path + `?parentId=${item.id}&childrenId=${item.id}`;
            // } else {
            //   path = item.path + `?parentId=${item.parentId}&childrenId=${item.id}`;
            // }
            // this.$router.push(path);
        },
        // 切换抽屉左侧list
        changeActive(value) {
            // this.parentNode = item;
            this.drawerActive = value
        },
        // 抽屉移入事件
        drawerMouseover() {
            this.showDrawer = true
        },
        // tab-item移入事件
        tabMouseover(item) {
            if (!this.$route.path.includes('category')) {
                this.showDrawer = item.showDrawer
            }
        },
        // tab-item移出事件
        mouseout() {
            this.showDrawer = false
        },
        // 元素周期表选择事件
        choiceEle(value) {
            console.log(value)
        }
    }
}
</script>

<style lang="less" scoped>
/deep/ .el-carousel__container {
    height: 580px;
}

/deep/ .el-carousel__arrow--left {
    width: 60px;
    height: 60px;
    background-color: black;
    opacity: .4;

}

/deep/ .el-carousel__arrow--right {
    width: 60px;
    height: 60px;
    background-color: black;
    opacity: .4;
}

/deep/ .el-carousel__arrow--right {
    width: 60px;
    height: 60px;
    background-color: black;
    opacity: .4;
}

.home {
    height: 100%;
    background-color: #f8f8f8;

    .panel {
        height: 580px;
        position: relative;

        /deep/ .el-carousel__indicator--horizontal {
            button {
                background: #a6a6a6
            }

        }

        /deep/.el-carousel__arrow--right {
            right: 160px;
            background-color: #989898;
        }

        /deep/.el-carousel__arrow--left {
            left: 160px;
            background-color: #989898;
        }

        /deep/ .el-carousel__indicator--horizontal.is-active {
            button {
                background-color: #fff;
            }
        }


        /deep/ .el-carousel__button {
            width: 10px;
            height: 10px;
            border-radius: 50%;
        }

        /deep/ .el-carousel__indicators--horizontal {
            bottom: 100px;
        }

        .banner_item {
            cursor: pointer;
        }


        .join_mc {
            position: absolute;
            left: 50%;
            bottom: -49px;
            transform: translate(-50%, 0);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 10;

            .join_mc_item {
                width: 310px;
                height: 116px;
                background: #fff;
                box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
                border-radius: 12px 12px 12px 12px;
                margin-right: 14px;
                display: flex;
                align-items: center;
                cursor: pointer;
                position: relative;
            }

            .join_tag {
                position: absolute;
                right: 0;
                top: -15px;
                height: 25px;
                padding: 0 10px;
                line-height: 25px;
                font-size: 12px;
                background-color: #fe9b05;
                text-align: left;
                color: #fff;
                border-radius: 30px 30px 30px 0;
            }

            .join_mc_icon {
                width: 72px;
                height: 72px;
                margin-left: 16px;
                margin-right: 12px;
            }

            .join_mc_content {
                text-align: left
            }

            .join_mc_title {
                height: 25px;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: bold;
                font-size: 18px;
                color: #100926;
                line-height: 21px;
                text-align: left;
                font-style: normal;
                margin-bottom: 8px;
            }

            .join_mc_subtitle {
                height: 20px;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 14px;
                color: #9099b7;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                text-transform: none;
            }
        }
    }

    .gold {
        width: 100%;
        // min-height: 815px;
        padding-top: 120px;
        padding-bottom: 60px;
        background: #F6F1FD;
        border-radius: 0px 0px 0px 0px;
        display: flex;
        flex-direction: column;
        align-items: center;


        .tabs {
            width: 1280px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 12px 12px 12px 12px;
            margin-bottom: 16px;

            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 24px;
            line-height: 28px;
            font-style: normal;
            text-transform: none;

            .tab_item {
                cursor: pointer;
                width: 100%;
                text-align: center;
                height: 64px;
                line-height: 64px;
                text-align: center;
                border-radius: 12px 12px 12px 12px;
                color: #000000;
                margin-right: 16px;
                font-size: 32px;
                font-weight: 600;
                display: flex;
                align-items: center;
                justify-content: center;

                position: relative;

                .eng {
                    // width: 212px;
                    height: 45px;
                    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                    font-weight: bold;
                    font-size: 32px;
                    color: #100926;
                    line-height: 38px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                    position: absolute;
                    top: -3px;
                    opacity: 0.1;
                }


                .line {
                    width: 42px;
                    height: 2px;
                    background-color: #6e39de;
                    margin: 0 18px;
                }

            }

            .tab_item:last-child {
                margin-right: 0;
            }

            .tab_item_active {
                background: #6742D6;
                color: #FFFFFF;
            }
        }

        .content {
            width: 1280px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;

            .content_item {
                cursor: pointer;
                width: 632px;
                height: 254px;
                padding: 20px 15px 10px 10px;
                background: #FFFFFF;
                box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
                border-radius: 12px 12px 12px 12px;
                margin-bottom: 16px;
                display: flex;
                border: 1px solid transparent;

                .left {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;
                    margin-right: 40px;
                    padding-left: 15px;

                    .counts {
                        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                        font-weight: normal;
                        font-size: 12px;
                        color: #888493;
                        line-height: 14px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;

                        span {
                            color: rgba(255, 134, 28, 1);
                            font-weight: bold;
                        }
                    }

                    .img {
                        width: 263px;
                        height: 138px;
                    }

                    .btn {
                        width: 155px;
                        height: 40px;
                        background: #6742D6;
                        border-radius: 12px 12px 12px 12px;
                        text-align: center;
                        line-height: 40px;

                        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                        font-weight: normal;
                        font-size: 16px;
                        color: #FFFFFF;
                        font-style: normal;
                        display: none;
                    }

                    .left_txt {
                        height: 40px;
                        max-width: 256px;
                        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                        font-weight: bold;
                        font-size: 18px;
                        color: #6742D6;
                        line-height: 40px;
                        font-style: normal;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;

                    }





                }



                .right {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-center;

                    .right_title {
                        width: 260px;
                        height: 39px;
                        overflow: hidden;
                        /* 超出部分隐藏 */
                        white-space: nowrap;
                        /* 文本不换行 */
                        text-overflow: ellipsis;
                        /* 超出部分显示省略号 */
                        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                        font-weight: 600;
                        font-size: 28px;
                        color: #100926;
                        line-height: 33px;
                        text-align: left;
                        font-style: normal;
                        margin-bottom: 6px;
                    }

                    .status {
                        display: flex;
                        height: 22px;
                        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                        font-weight: normal;
                        font-size: 12px;
                        font-style: normal;
                        text-align: center;
                        line-height: 22px;
                        margin-bottom: 13px;
                    }

                    .status_item {
                        min-width: 52px;
                        height: 22px;
                        // background: rgba(132, 94, 246, .3);
                        border-radius: 6px 6px 6px 6px;
                        margin-right: 8px;
                        line-height: 22px;
                    }

                    .type {
                        width: 280px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        margin-bottom: 16px;

                        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                        font-weight: 600;
                        font-size: 14px;
                        color: #100926;
                        line-height: 22px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }

                    .type_eng {
                        margin-bottom: 16px;
                    }

                    .right_desc {
                        width: 280px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 4;

                        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                        font-weight: normal;
                        font-size: 12px;
                        color: rgba(16, 9, 38, .5);
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                }
            }

            .content_item:hover {
                border: 1px solid #845EF6;

                .btn {
                    display: block;
                }

                .left_txt {
                    display: none;
                }
            }
        }

        .content_item:last-child {
            margin-right: 0;
        }

        .content1 {
            width: 1280px;
            margin-bottom: 120px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .content1_item {
                width: 308px;
                height: 368px;
                background: #FFFFFF;
                box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
                border-radius: 12px 12px 12px 12px;
                margin-bottom: 12px;
                border: 1px solid transparent;
                // border: 1px solid #845EF6;
            }

            .img {
                width: 306px;
                height: 259px;
                border-radius: 11px 11px 0px 0px;
                margin-bottom: 21px;
            }

            .title {
                height: 34px;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 24px;
                color: #100926;
                line-height: 28px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-bottom: 6px;
                margin-left: 16px;
            }

            .subtitle {
                height: 20px;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 14px;
                color: #8892b0;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-left: 16px;
            }

            .content1_item:hover {
                border: 1px solid #845EF6;

                .title,
                .subtitle {
                    color: #845EF6;
                }

            }
        }
    }

    .test {
        width: 100%;
        height: 1109px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 50px;
        padding-top: 38px;

        .title {
            height: 45px;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: 600;
            font-size: 32px;
            color: #100926;
            line-height: 38px;
            font-style: normal;
            text-transform: none;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            justify-content: center;

            position: relative;

            .eng {
                // width: 212px;
                height: 45px;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: bold;
                font-size: 32px;
                color: #100926;
                line-height: 38px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                position: absolute;
                top: -15px;
                opacity: 0.1;
            }


            .line {
                width: 42px;
                height: 2px;
                background-color: #6e39de;
                margin: 0 18px;
            }




        }

        .desc1 {
            width: 1280px;
            height: 48px;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 16px;
            color: #100926;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-bottom: 32px;
        }

        .img {
            width: 1280px;
            height: 435px;
            border-radius: 12px 12px 12px 12px;
            margin-bottom: 32px;
        }

        .desc2 {
            width: 1280px;
            height: 48px;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 16px;
            color: #100926;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-bottom: 56px;
        }

        .imgs {
            width: 1280px;
            height: 208px;
            display: flex;
            align-items: center;
            margin-bottom: 48px;

            .item {
                width: 404px;
                height: 208px;
                // background: linear-gradient( 180deg, rgba(16,9,38,0) 29%, #100926 100%);
                border-radius: 12px 12px 12px 12px;
                position: relative;
                margin-right: 34px;
                padding-left: 24px;
                padding-top: 105px;

                display: flex;
                flex-direction: column;
                align-items: self-start;

                .item_img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    border-radius: 12px 12px 12px 12px;
                    z-index: 0;
                }

                .title {
                    height: 34px;
                    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                    font-weight: normal;
                    font-size: 24px;
                    color: #FFFFFF;
                    line-height: 28px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                    margin-bottom: 8px;
                }

                .subtitle {
                    width: 350px;
                    height: 40px;
                    display: -webkit-box;
                    /* 设置为WebKit内核的弹性盒子模型 */
                    -webkit-box-orient: vertical;
                    /* 垂直排列 */
                    -webkit-line-clamp: 2;
                    /* 限制显示两行 */
                    overflow: hidden;
                    /* 隐藏超出范围的内容 */
                    text-overflow: ellipsis;
                    /* 使用省略号 */
                    height: 40px;
                    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                    font-weight: normal;
                    font-size: 14px;
                    color: #FFFFFF;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                    position: relative;
                    line-height: 20px;
                    z-index: 2;
                    opacity: 0.8;
                }
            }

            .item:last-child {
                margin-right: 0;
            }

        }

        .test_btn {
            width: 202px;
            height: 54px;
            background: #6742D6;
            border-radius: 12px 12px 12px 12px;
            text-align: center;
            line-height: 54px;
            cursor: pointer;

            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 18px;
            color: #FFFFFF;
            font-style: normal;
            text-transform: none;
        }
    }

    // .speech {
    //     width: 100%;
    //     height: 601px;
    //     background-color: #F6F1FD;
    //     padding: 51px 0px;
    //     display: flex;
    //     flex-direction: column;
    //     align-items: center;

    //     .title {
    //         height: 45px;
    //         font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
    //         font-weight: 600;
    //         font-size: 32px;
    //         color: #100926;
    //         font-style: normal;
    //         text-transform: none;
    //         margin-bottom: 24px;

    //         display: flex;
    //         align-items: center;
    //         justify-content: center;

    //         .line {
    //             width: 30px;
    //             height: 6px;
    //             background-color: #6e39de;
    //             border-radius: 10px;
    //             margin: 0 10px;
    //         }
    //     }

    //     .speech_content {
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;
    //         cursor: pointer;

    //         .item {
    //             width: 306px;
    //             height: 418px;

    //             background: #FFFFFF;
    //             box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
    //             border-radius: 12px 12px 12px 12px;
    //             border: 1px solid transparent;
    //             overflow: hidden;

    //             margin-right: 19px;

    //             .play {
    //                 width: 306px;
    //                 height: 287px;
    //                 position: relative;

    //                 .cover {
    //                     width: 306px;
    //                     height: 287px;
    //                     border-radius: 12px 12px 0px 0px;
    //                     margin-bottom: 24px;
    //                 }

    //                 .play_icon {
    //                     width: 60px;
    //                     height: 60px;
    //                     position: absolute;
    //                     left: 50%;
    //                     top: 44%;
    //                     transform: translate(-50%, -56%);
    //                 }

    //                 .people {
    //                     position: absolute;
    //                     left: 11px;
    //                     bottom: 2px;
    //                     display: flex;
    //                     align-items: center;
    //                     padding: 0 11px;

    //                     .avator {
    //                         width: 68px;
    //                         height: 68px;
    //                         border-radius: 50%;
    //                         margin-right: 16px;
    //                     }

    //                     .info {
    //                         padding-top: 20px;
    //                     }

    //                     .name {

    //                         height: 31px;
    //                         font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
    //                         font-weight: normal;
    //                         font-size: 22px;
    //                         color: #fff;
    //                         line-height: 26px;
    //                         text-align: left;
    //                         font-style: normal;
    //                         text-transform: none;
    //                         margin-bottom: 2px;
    //                     }

    //                     .people_title {
    //                         width: 160px;
    //                         height: 22px;
    //                         overflow: hidden;
    //                         text-overflow: ellipsis;
    //                         white-space: nowrap;
    //                         font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
    //                         font-weight: normal;
    //                         font-size: 16px;
    //                         color: #fff;
    //                         line-height: 19px;
    //                         text-align: left;
    //                         font-style: normal;
    //                     }
    //                 }
    //             }


    //             .desc_wrap {
    //                 padding: 12px;
    //             }

    //             .desc {
    //                 width: 283px;
    //                 height: 96px;
    //                 font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
    //                 font-weight: normal;
    //                 font-size: 14px;
    //                 line-height: 24px;
    //                 text-align: left;
    //                 font-style: normal;
    //                 text-transform: none;
    //                 color: #8c95b3;

    //                 display: -webkit-box;
    //                 /* 设置为WebKit内核的弹性盒子模型 */
    //                 -webkit-box-orient: vertical;
    //                 /* 垂直排列 */
    //                 -webkit-line-clamp: 4;
    //                 /* 限制显示两行 */
    //                 overflow: hidden;
    //                 /* 隐藏超出范围的内容 */
    //                 text-overflow: ellipsis;
    //                 /* 使用省略号 */

    //             }

    //         }

    //         .item:hover {
    //             border: 1px solid #845FF6;
    //         }

    //         .item:last-child {
    //             margin-right: 0;
    //         }
    //     }
    // }


    .expert_comments {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 40px;
        padding-bottom: 63px;
        background: #F6F1FD;

        .title {
            height: 45px;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: 600;
            font-size: 32px;
            color: #100926;
            font-style: normal;
            text-transform: none;
            margin-bottom: 24px;

            display: flex;
            align-items: center;
            justify-content: center;


            position: relative;

            .eng {
                // width: 212px;
                height: 45px;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: bold;
                font-size: 32px;
                color: #100926;
                line-height: 38px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                position: absolute;
                top: -13px;
                opacity: 0.1;
            }


            .line {
                width: 42px;
                height: 2px;
                background-color: #6e39de;
                margin: 0 17px;
            }
        }

        .content {
            width: 1280px;
            display: flex;
            justify-content: space-between;

            .content_item {
                width: 23.5%;
                height: 390px;
                background-color: #fff;
                border-radius: 4px 4px 0 0;
                overflow: hidden;
                box-shadow: 2px 2px 15px 0px rgba(0, 0, 0, 0.25);

                .top {
                    width: 100%;
                    height: 154px;
                    position: relative;
                    cursor: pointer;

                    /deep/ .el-image {
                        width: 100%;
                        height: 154px;
                    }

                    img {
                        width: 100%;
                        height: 154px;
                    }

                    .play {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);

                        img {
                            width: 45px;
                            height: 45px;
                        }
                    }
                }

                .bottom {
                    width: 100%;
                    height: 236px;
                    background-image: url(@/assets/imgs/bg1.png);
                    background-size: cover;
                    padding: 20px;
                    padding-right: 4px;
                    overflow: hidden;

                    .info {
                        display: flex;
                        align-items: center;
                        height: 85px;

                        .face {
                            width: 60px;
                            height: 60px;
                            border-radius: 50%;
                            overflow: hidden;
                            flex-shrink: 0;
                            margin-right: 12px;

                            .xl-img {
                                max-width: 100%;
                            }
                        }

                        .text {
                            text-align: left;
                            color: @main-color;

                            .name {
                                font-size: 20px;
                                font-weight: 700;
                                margin-bottom: 4px;
                            }

                            .theme {
                                font-size: 14px;
                            }
                        }
                    }

                    .dep {
                        color: #474747;

                        p {
                            font-size: 12px;
                            text-align: left;
                            margin-bottom: 6px;
                            position: relative;
                            padding-left: 14px;
                            padding-right: 14px;

                            .icon {
                                position: absolute;
                                width: 8px;
                                height: 8px;
                                border-radius: 50%;
                                background-color: #474747;
                                left: 0;
                                top: 4px;
                            }

                            .text {
                                line-height: 14px;
                                color: #474747;
                            }
                        }
                    }
                }
            }
        }
    }

    .paper {
        width: 100%;
        background: #FFFFFF;
        padding-top: 37px;
        padding-bottom: 57px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
            width: 1280px;
            height: 45px;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: 600;
            font-size: 32px;
            color: #100926;
            line-height: 38px;
            font-style: normal;
            margin-bottom: 24px;
            display: flex;
            justify-content: center;
            align-items: center;

            position: relative;

            .eng {
                // width: 212px;
                height: 45px;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: bold;
                font-size: 32px;
                color: #100926;
                line-height: 38px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                position: absolute;
                top: -15px;
                opacity: 0.1;
            }


            .line {
                width: 42px;
                height: 2px;
                background-color: #6e39de;
                margin: 0 19px;
            }

        }

        .content {
            width: 1280px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            margin-bottom: 30px;

            .item {
                width: 411px;
                height: 352px;
                background: #FFFFFF;
                box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
                margin-right: 23px;
                margin-bottom: 24px;
                padding: 16px 18px;
                cursor: pointer;
                border-radius: 12px 12px 12px 12px;


                .img {
                    width: 375px;
                    height: 210px;
                    border-radius: 12px 12px 12px 12px;
                    margin-bottom: 24px;
                }

                .subtitle {
                    height: 48px;
                    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                    font-weight: bold;
                    font-size: 18px;
                    color: #100926;
                    line-height: 24px;
                    text-align: left;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 2;
                    font-style: normal;
                    text-transform: none;
                    margin-bottom: 12px;
                }

                .foot {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .foot_item {
                        display: flex;
                        align-items: center;
                        height: 24px;
                        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                        font-weight: normal;
                        font-size: 12px;
                        color: #aeb8d3;
                        line-height: 24px;
                        font-style: normal;

                        .icon {
                            width: 14px;
                            height: 14px;
                            margin-right: 4px;
                        }
                    }

                    .foot_item:last-child {
                        margin-right: 0;
                    }


                }
            }

            .item:nth-child(3n) {
                margin-right: 0;
            }
        }

        .page {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .click {
                text-decoration: underline;
                cursor: pointer;
                margin-right: 20px;
            }
        }

        //
        .more_btn {
            width: 202px;
            height: 54px;
            background: #6742D6;
            border-radius: 12px 12px 12px 12px;
            text-align: center;
            line-height: 54px;
            cursor: pointer;

            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 18px;
            color: #FFFFFF;
            font-style: normal;
            text-transform: none;
        }
    }

    .service_custom {
        width: 100%;
        background: #F6F1FD;
        padding-top: 40px;
        padding-bottom: 50px;

        .service_title {
            width: 100%;
            text-align: center;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: bold;
            font-size: 32px;
            color: #100926;
            line-height: 38px;
            font-style: normal;
            text-transform: none;
            padding-bottom: 41px;

            display: flex;
            align-items: center;
            justify-content: center;

            position: relative;

            .line {
                width: 42px;
                height: 2px;
                background-color: #6e39de;
                margin: 0 18px;
            }

            .eng {
                // width: 212px;
                height: 45px;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: bold;
                font-size: 32px;
                color: #100926;
                line-height: 38px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                position: absolute;
                top: -18px;
                opacity: 0.1;
            }
        }

        .service_content {
            width: 100%;
            margin: 0 auto;
            overflow: hidden;

            ul {
                list-style: none;
                padding: 0;
                margin: 0 auto;

                &.ul-item {
                    display: flex;

                    .li-item {
                        width: 1280px;
                        height: 330px;
                        line-height: 120px;
                        color: #fff;
                        text-align: center;
                        font-size: 30px;

                        display: flex;
                        flex-wrap: wrap;

                        .logo_item_wrap {
                            width: 300px;
                            height: 96px;
                            background: #FFFFFF;
                            // box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
                            border-radius: 8px 8px 8px 8px;
                            border: 1px solid #845FF6;
                            margin-right: 20px;
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            .logo_item {
                                width: 212px;
                                height: 66px;
                            }
                        }
                    }
                }
            }
        }






    }
}

// 服务客户的轮播样式
.el-carousel__item .item {
    width: 300px;
    height: 96px;
    box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #845FF6;
}


/deep/ .service_content .el-carousel__container {
    width: 1280px !important;
    display: flex;
    justify-content: space-between;
}
</style>
